import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import { MyClaimDocumentLineAttachmentModel} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MyClaimDocumentLineAttachmentService extends BaseApiTemplateService<MyClaimDocumentLineAttachmentModel> {

  endpointSubPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'document-line-attachments/' ;
  readonly url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpointSubPath + 'backoffice-ep';
    this.endpoint_path = this.endpointSubPath + 'backoffice-ep';
    this.httpClient = http;
  }

  uploadImage(formData: FormData, lineGuid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'add-files/' + 'backoffice-ep?claim_doc_line_guid=' + lineGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpointSubPath + 'add-files/' + 'backoffice-ep?claim_doc_line_guid=' + lineGuid;
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  updateImage(formData: FormData, attachmentLineGuid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'replace-files/backoffice-ep/' + attachmentLineGuid;
    console.log(this.apiUrl + 'photo', formData);
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpointSubPath + 'replace-files/backoffice-ep/' + attachmentLineGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  uploadImageByAttachmentFlow(formData: FormData, attachmentFlowGuid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'add-files/' + 'backoffice-ep/' + attachmentFlowGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpointSubPath + 'add-files/' + 'backoffice-ep/' + attachmentFlowGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  getImage(lineGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'files/backoffice-ep/' + lineGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpointSubPath + 'files/backoffice-ep/' + lineGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

}


